import React from 'react'
import { useSelector } from 'react-redux'

import Box from '@mui/material/Box'

import { selectMarqueeBox } from '../ui/uiSlice'

const classes = {
  selectionBox: {
    // .selectionBox {
    // Placed in the page's own coordinates, like the stikis beside it.
    position: 'absolute',
    margin: 0,
    padding: 0,
    border: '1px dashed black',
    background: 'rgba(163, 210, 255, 0.2)',
    zIndex: 2,
    pointerEvents: 'none',
  },
}

// The box drawn while shift-dragging to select stikis. It used to be a plain
// `div` with an `sx` prop, which only MUI components read, so none of its
// styles applied and it was never seen.
export default function SelectionBox() {
  const { left, top, width, height } = useSelector(selectMarqueeBox)

  return (
    <Box
      className='selectionBox'
      sx={classes.selectionBox}
      style={{
        left: `${left}em`,
        top: `${top}em`,
        width: `${width}em`,
        height: `${height}em`,
      }}
    ></Box>
  )
}
